import Module from "../../../../../hebelsolar-md/src/classes/Module.js";
var debug = false;

class Generator { 
        id= "";
        deviceType= "generator";
        code= ""; 
        description="" ;
        manufacturer= "";
        warranty = 0;
        performanceWarranty = 0;
        //needStringBox= true;
        efficiency= 97.8;

        //Packing info
        weight= 80;
        height= 705;
        width= 650;
        depth= 283;
        dcPowerWpModule=330;
        dcPower=5;
        acPower=  3; 
        acVoltage= 220; 
        acPhases= 3; 
        //acMaxCurrent= 13; 
    
        //dcMinPower= 2.1;
        //dcMaxPower= 3.96; 
        //dcMaxVoltage =500;
        quantity= 0;

        nMax= 0;
        nMin= 0;
        
        unit = "peça (s)"
       
        product = { 
            price:0,
            cost:0,
           // taxes:0,
            sellerId:"", //Now its a string
            available:true, //editted by the user,
            we:{
                ativoMatriz:false,
                ativoIntegrador:false,
                ativoFranquia:false,
                custoUsdAtivo:false,
                custoUsd:0,
                precoTargetUsd:0,
        
              }

        };



        constructor(){
        };
        clone(object){
            // var self = this;
            // self = Object.assign(self , object);
            Object.assign(this, object );
          };

        //clone(i){
            //this = Object.assign(this, i);
            // this.id = i.id;
            // this.deviceType = "generator";
            // this.code = i.code;
            // this.description = i.description;
            // this.manufacturer = i.manufacturer;
            // //this.needStringBox = i.needStringBox;
            // this.efficiency = i.efficiency;
            // this.weight = i.weight;
            // this.height = i.height;
            // this.width = i.width;
            // this.depth = i.depth;
            // this.dcPower =  i.dcPower;
            // this.acPower = i.acPower;  
            // this.acVoltage = i.acVoltage;
            // this.acPhases =  i.acPhases;
            // this.quantity = i.quantity;
            // this.warranty = i.warranty;
            // this.performanceWarranty = i.performanceWarranty;
            // this.modules = i.modules;
            // if(i.unit)
            //     this.unit = i.unit;
            // this.product = i.product;
        //}
        

        


}




export default Generator;
